import { terminateDriver } from "../../store/actions/DeliveryDrivers";
import { Api } from "../config/request";

export default {
  getDriversCount(queryParams) {
    return Api.get(`/drivers/status-count${queryParams}`);
  },
  getDriversList(queryParams) {
    return Api.get(`/drivers${queryParams}`);
  },
  getDriverBasicDetails(driverId) {
    return Api.get(`/drivers/${driverId}/basic-details`);
  },
  getDriverAssignmentStatus(driverId) {
    return Api.get(`/drivers/${driverId}/assignment-status`);
  },
  updateDriverAssignmentStatus(driverId, data) {
    return Api.put(`/drivers/${driverId}/assignment-status`, data);
  },
  getDriverAdditionalDetails(driverId) {
    return Api.get(`/drivers/${driverId}/additional-details`);
  },
  getDriverAssetDetails(driverId) {
    return Api.get(`/drivers/${driverId}/assets`);
  },
  getDriverStoreMappingDetails(driverId) {
    return Api.get(`/driver-store-mapping/stores?driver_id=${driverId}`);
  },
  getDriverReservationDetails(driverId) {
    return Api.get(`/drivers/${driverId}/reservations`);
  },
  getDriverServicesDetails(driverId) {
    return Api.get(`/drivers/${driverId}/services`);
  },
  getEligibleDriverServices(driverId) {
    return Api.get(`/drivers/${driverId}/services/eligible`);
  },
  updateDriverServicesDetails(driverId, payload) {
    return Api.put(`/drivers/${driverId}/services`, payload);
  },
  getDriverLocalitiesDetails(driverId) {
    return Api.get(`/drivers/${driverId}/localities`);
  },
  updateDriverLocalitiesDetails(driverId, payload) {
    return Api.put(`/drivers/${driverId}/localities-details`, payload);
  },
  getDriverFinancialDetails(driverId) {
    return Api.get(`/drivers/${driverId}/financial-details`);
  },
  getDriverLogsDetails(driverId) {
    return Api.get(`/drivers/${driverId}/change-logs`);
  },
  getDriverDeliveryStatuses() {
    return Api.get("/drivers/delivery-statuses");
  },
  getDriverDeliveryServices() {
    return Api.get("/drivers/delivery-services");
  },
  getDriverLifecycleStatuses() {
    return Api.get("/drivers/lifecycle-statuses");
  },
  updateDriverBasicDetails(driverId, payload) {
    return Api.put(`/drivers/${driverId}/basic-details`, payload);
  },
  getOTPDriverBasicDetails(driverId, payload, isResend) {
    return Api.post(
      `/drivers/${driverId}/basic-details/otp/${isResend ? "resend" : "send"}`,
      payload
    );
  },
  updateDriverAdditionalDetails(driverId, payload) {
    return Api.put(`/drivers/${driverId}/additional-details`, payload);
  },
  getOTPDriverAdditionalDetails(driverId, payload, isResend) {
    return Api.post(
      `/drivers/${driverId}/additional-details/otp/${
        isResend ? "resend" : "send"
      }`,
      payload
    );
  },
  updateDriverFinancialDetails(driverId, payload) {
    return Api.put(`/drivers/${driverId}/financial-details`, payload);
  },
  getOTPDriverFinancialDetails(driverId, payload, isResend) {
    return Api.post(
      `/drivers/${driverId}/financial-details/otp/${
        isResend ? "resend" : "send"
      }`,
      payload
    );
  },
  getDriverProfessions() {
    return Api.get("/profession");
  },
  getDriverEducations() {
    return Api.get("/education/fields");
  },
  getDriverEducationQualifications() {
    return Api.get("/education/qualifications");
  },
  driverVerifyPhoneNumberChange(driverId, phoneNo) {
    return Api.get(
      `/drivers/${driverId}/validate-phone-number-change?phone_no=${phoneNo}`
    );
  },
  getDriverBankVerificationStatus(driverId, payload) {
    return Api.post(`/drivers/${driverId}/bank-verification-status`, payload);
  },
  verifyDriverBankDetails(driverId, payload) {
    return Api.post(`/drivers/${driverId}/verify-bank-details`, payload);
  },
  getDriverActionReasons(action) {
    return Api.get(`/action/${action}/reasons`);
  },
  terminateDriver(driverId, payload) {
    return Api.post(`/drivers/${driverId}/terminate`, payload);
  },
  resignDriver(driverId, payload) {
    return Api.post(`/drivers/${driverId}/resign`, payload);
  },
  forceOfflineDriver(driverId) {
    return Api.post(`/drivers/${driverId}/force-offline`);
  },
  notifyDriver(driverId, payload) {
    return Api.post(`/drivers/${driverId}/notify`, payload);
  },
  clearSelfieCampaignDriver(driverId) {
    return Api.post(`/drivers/${driverId}/clear_selfie_campaign`, {});
  },
  getDriverDocuments(driverId, payload) {
    return Api.post(`/drivers/${driverId}/documents`, payload);
  },
  updateDriverDocuments(driverId, payload) {
    return Api.put(`/drivers/${driverId}/documents`, payload);
  },
  verifyDriverDocuments(paylaod) {
    return Api.post("/drivers/verify-documents", paylaod);
  },
  getDriverMigrationDetails(driverId) {
    return Api.get(`/drivers/${driverId}/migration-details`);
  },
};
